// News post: Local and YouTube Video Handling Supported (November 25, 2024)
import React from 'react';
import support_asset from '../../../assets/images/blog/blog-YTLsupport-asset.jpg';

const LocalAndYouTubeSupport = () => (
  <>
    <p>
      We are excited to announce that our platform now supports both <strong>local video uploads</strong> and <strong>YouTube video
      analysis</strong>. This new capability opens up a world of possibilities for managing and extracting insights from your video
      content, regardless of its source.
    </p>

    <h2>Local Video Uploads</h2>
    <p>
      With our enhanced video handling features, you can now upload local videos directly to our platform. This allows you to analyze
      and process videos stored on your device, making it easier to work with proprietary or offline content.
    </p>

    <h2>YouTube Video Analysis</h2>
    <p>
      In addition to local videos, our platform continues to offer comprehensive analysis for YouTube content. Whether your videos are
      public or unlisted, our AI-powered tools transform raw footage into structured, actionable insights.
    </p>
    <p>
      By supporting both local and YouTube videos, we provide a unified solution that caters to diverse content needs. This dual
      approach not only simplifies your workflow but also enables richer data extraction and improved content management across
      various platforms.
    </p>

    <figure>
      <img src={support_asset} alt="Local files and YouTube links processed side by side" loading="lazy" width="1860" height="944" />
    </figure>

    <h2>Experience the Difference Today</h2>
    <p>
      Ready to take your video content analysis to the next level? Explore our enhanced capabilities and see how our platform can
      streamline your workflow—whether you’re handling local files or analyzing YouTube videos.
    </p>
  </>
);

export default LocalAndYouTubeSupport;
